import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { locales, type Locale } from "./locales";

function currentLocale(language: string): Locale {
  return (locales as readonly string[]).includes(language) ? language as Locale : "en";
}

/** Keeps the selected language in shareable internal URLs; English is the clean default URL. */
export function localizedPath(path: string, language: string): string {
  const url = new URL(path, "https://trees.cy");
  const locale = currentLocale(language);
  if (locale === "en") url.searchParams.delete("lang");
  else url.searchParams.set("lang", locale);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function useLocalizedPath(): (path: string) => string {
  const { i18n } = useTranslation();
  return useCallback((path: string) => localizedPath(path, i18n.language), [i18n.language]);
}

export function catalogueReturnPath(state: unknown): string {
  const candidate = state && typeof state === "object" && "catalogueReturn" in state
    ? (state as { catalogueReturn: unknown }).catalogueReturn : null;
  return typeof candidate === "string" && /^\/catalog(?:\?|$)/.test(candidate) ? candidate : "/catalog";
}
